export const users = {
  reset: {
    error:
      "Cette action ne peut pas être effectuée maintenant. Le compte de l'utilisateur cible est inchangé. Veuillez réessayer plus tard. Si cela persiste, veuillez créer <a>un ticket de problème de compte</a> dans notre service d'assistance.",
    password: {
      action: "Réinitialiser le mot de passe",
      info: "Réinitialise le mot de passe de l'utilisateur en lui envoyant un e-mail avec un lien pour réinitialiser son mot de passe. <br/><br/> Note : cette action n'a aucun effet si l'utilisateur se connecte via SSO. <br/><br/> Veuillez consulter <docsLink>cette page de notre documentation d'aide</docsLink> pour le dépannage et la résolution des problèmes de connexion.",
      warning:
        "Ce lien n'est <b>valide que pendant 1 heure</b>, par conséquent coordonnez un moment de récupération avec l'utilisateur cible en conséquence. Si la fenêtre d'1 heure est manquée, il sera verrouillé hors de son compte jusqu'à ce que cette action de réinitialisation de mot de passe soit effectuée à nouveau.",
    },
    mfa: {
      action: "Réinitialiser l'AMF",
      info: "Réinitialise l'authentificateur multi-facteurs de l'utilisateur (Okta Verify, Google Authenticator ou les deux). Il sera invité à réinitialiser son AMF à nouveau lors de sa prochaine connexion. <br/><br/> Veuillez consulter <docsLink>cette page de notre documentation d'aide</docsLink> pour le dépannage et la résolution des problèmes de connexion.",
    },
  },
  deactivate: "Désactiver",
  resend: "Renvoyer",
  After_confirmation_this_invitation_will_be_deleted_and_user_lose_access:
    "Après confirmation, cette invitation sera supprimée et l'utilisateur perdra l'accès.",
  After_confirmation_this_person_will_be_deactivate_and_lose_access:
    "Après confirmation, cette personne sera désactivée et perdra l'accès.",
  Are_you_sure_you_want_to_deactivate: "Êtes-vous sûr de vouloir désactiver ?",
  Are_you_sure_you_want_to_delete_invitation: "Êtes-vous sûr de vouloir supprimer l'invitation ?",
  Assign_roles: "Assigner des rôles",
  Create_another_user: "Créer un autre utilisateur",
  Edit_User: "Modifier l'utilisateur",
  Email: "E-mail",
  activate: "Activer",
  First_Name: "Prénom",
  Here_you_will_manage_companys_users: "Ici vous gérerez les utilisateurs de l'entreprise",
  Invite_New_User: "Inviter un nouvel utilisateur",
  Invite_New_Users: "Inviter de nouveaux utilisateurs",
  Job_Title: "Titre du poste",
  Roles: "Rôles",
  Status: "Statut",
  Surname: "Nom de famille",
  Update_user: "Mettre à jour l'utilisateur",
  Use_this_window_to_setup_a_new_user:
    "Utilisez cette fenêtre pour inviter un nouvel utilisateur. Un utilisateur peut avoir plusieurs rôles sauf pour le rôle 'Vérificateur'.",
  Users: "Utilisateurs",
  users_management: "gestion des utilisateurs",
  no_users_added_yet: "Vous n'avez encore ajouté aucun utilisateur.",
  status_options: {
    invited: "Invité",
    invitation_expired: "Invitation expirée",
    active: "Actif",
    deactivated: "Désactivé",
  },
} as const;
